import React from 'react';
import PropTypes from 'prop-types';

import './BarsLoadingIndicator.css';

const BarsLoadingIndicator = ({ variant, size, classes = '', style }) => {
    let src = 'https://static.abouthotelier.com/img/bars.svg';

    if (variant === 'puff') {
        src = 'https://static.abouthotelier.com/img/puff.svg';
    }

    return (
        <div className={`ab-bars-loading-indicator ${classes}`} style={style}>
            <img src={src} alt="Loading indicator" width={size} height={size} />
        </div>
    );
};

BarsLoadingIndicator.propTypes = {
    variant: PropTypes.string,
    size: PropTypes.number,
    classes: PropTypes.string,
    style: PropTypes.object,
};

BarsLoadingIndicator.defaultProps = {
    variant: '',
    size: 20,
};

export default BarsLoadingIndicator;
